__turbopack_context__.v({
  "className": "euclidcircularbregular_bb0293dc-module__VwQ6Xq__className",
});
